import { render, staticRenderFns } from "./downloadQRCode.vue?vue&type=template&id=ddd002d6&"
import script from "./downloadQRCode.vue?vue&type=script&lang=js&"
export * from "./downloadQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports